// ── Paper crane fold ritual types (Round 14 Phase A) ──
// ── Constants ──
/** Duration of the fold ritual in milliseconds (30 real seconds per plan-14 §2A). */
export const CRANE_FOLD_DURATION_MS = 30_000;
/** Maximum length of a crane's authored message (plan-14 §2A: 200 chars). */
export const CRANE_FOLD_MAX_MESSAGE_CHARS = 200;
/** Materials consumed by a single fold: 1 cloth + 1 ink. */
export const CRANE_FOLD_COST = { cloth: 1, ink: 1 };
// ── Messages ──
/** Client → Server: begin folding a paper crane. */
export const MSG_CRANE_FOLD_START = 'crane_fold_start';
/** Client → Server: cancel an in-progress fold. */
export const MSG_CRANE_FOLD_CANCEL = 'crane_fold_cancel';
/** Client → Server: complete fold and release the crane with message + address. */
export const MSG_CRANE_FOLD_RELEASE = 'crane_fold_release';
/** Server → Client: fold state sync (progress, completion, errors). */
export const MSG_CRANE_FOLD_STATE = 'crane_fold_state';
// ── Crane drift messages (Round 14 Phase B) ──
/** Server → Client: a crane is drifting through the player's realm.
 *  Sent on realm-join sync and periodically (~10s) as position advances. */
export const MSG_CRANE_CROSSING = 'crane_crossing';
/** Server → Client: a crane left the player's realm or was delivered.
 *  Client removes the sprite. */
export const MSG_CRANE_DEPARTED = 'crane_departed';
/** Server → Client: a crane arrived at the recipient's hearth. */
export const MSG_CRANE_ARRIVED = 'crane_arrived';
// ── Crane inbox messages (Round 14 Phase C) ──
/** Server → Client: bulk crane inbox sync on login. Sent once during
 *  onJoin when the character has delivered cranes waiting at their hearth. */
export const MSG_CRANE_INBOX = 'crane_inbox';
//# sourceMappingURL=paperCrane.js.map